/*
 * @Descripttion: 
 * @Author: xutao
 * @Date: 2020-11-02 09:50:06
 * @LastEditors: xutao
 * @LastEditTime: 2020-11-04 10:00:32
 * @FilePath: \yunjiactivity-h5\src\common\utils\commonUtil.js
 */

/**
 * 是否测试环境
 */
export function isTestEnv() {
    return location.hostname.search(/(v.|t.|txst.|t-do-dev.|special-al-dev.|special-al-dev-tmp.)/) == 0
}

function toNum(a) {
    a = (a || '').toString();
    //也可以这样写 var c=a.split(/\./);
    var c = a.split('.');
    var num_place = ["", "0", "00", "000", "0000"], r = num_place.reverse();
    for (var i = 0; i < c.length; i++) {
        var len = c[i].length;
        c[i] = r[len] + c[i];
    }
    var res = c.join('');
    return res;
}

/**
 * 版本号比较
 * @param {*} a 
 * @param {*} b 
 */
export function versionCompare(a, b) {
    var _a = toNum(a), _b = toNum(b);
    if (_a == _b) return 0
    if (_a > _b) return 1
    if (_a < _b) return -1
}
/**
 * 获取Android操作系统版本
 */
export function getAndroidOSVersion(){
    var u = window.navigator.userAgent
    let version = ''
	if(/android/i.test(navigator.userAgent)){
		version = u.replace(/^.*Android ([\d.]+);.*$/, '$1')
    }
    console.log('@xts>Android操作系统版本: ', version)
    return version
}
/**
 * 获取ios操作系统版本
 */
export function getAppleOSVersion(){
    var u = window.navigator.userAgent
    let version = ''
	if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
		version = u.replace(/^.*OS ([\d_]+) like.*$/, '$1').replace(/_/g, '.')
    }
    console.log('@xts>ios操作系统版本: ', version)
    return version
}

/**
 * 获取微信版本号
 */
export function getWXVersion(){
    let result = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
    let version = result && result[1] || ''
    console.log('@xts>微信版本: ', version)
    return version
}

/**
 * 手机号脱敏
 * @param {*} str 11位手机号码
 */
export function protectPhoneNum(str = ''){
    let pat=/(\d{3})\d*(\d{4})/
    let b=str.replace(pat,'$1****$2');
    return b
}


// window.versionCompare = versionCompare